export const DEFAULT_CATEGORY_PALETTE = [
  { activeColor: "#D73D35" },
  { activeColor: "#7DAC5E" },
  { activeColor: "#2F6980" },
  { activeColor: "#F2D45C" },
  { activeColor: "#8C3A8E" },
];

export const getCategoryPalette = (categories) => {
  return categories?.length ? categories : DEFAULT_CATEGORY_PALETTE;
};
